import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

interface ISeparatorProps {
  theme: ITheme // TODO:VJ : default import setup to be done
}
export const Separator = styled('div')<ISeparatorProps>`
  label: Separator;
  width: 100%;
  height: 1px;
  background: ${(props) => props.theme.colors.borderColor};
`
